var map = {
	"./ar.json": 3933,
	"./ch.json": 5305,
	"./en.json": 2007,
	"./fr.json": 6863,
	"./gr.json": 7546,
	"./it.json": 5866,
	"./ru.json": 2182,
	"./sp.json": 287
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1634;